<template lang="pug">
  betList(betType="TG")
</template>

<script>
import betList from "@/views/stock/_betList.vue";

export default {
  components: {
    betList
  }
};
</script>